export default {
    getCookiePreferences() {
        try {
            const cookieValue = document.cookie
                .split('; ')
                .find(row => row.startsWith('cookiePreferences='))
                ?.split('=')[1];
            
            if (cookieValue) {
                return JSON.parse(decodeURIComponent(cookieValue));
            }
        } catch (e) {
            console.error('Error parsing cookie preferences:', e);
        }
        return null;
    },
    
    saveCookiePreferences(preferences) {
        // Set expiry to 6 months
        const expiryDate = new Date();
        expiryDate.setMonth(expiryDate.getMonth() + 6);
        
        // Necessary cookies are always enabled
        preferences.necessary = true;
        
        // Set cookie with preferences
        const cookieValue = encodeURIComponent(JSON.stringify(preferences));
        document.cookie = `cookiePreferences=${cookieValue};expires=${expiryDate.toUTCString()};path=/;SameSite=Lax`;
        
        // Reload scripts based on preferences
        this.loadConsentedScripts(preferences);
    },
    
    hasConsent() {
        return this.getCookiePreferences() !== null;
    },
    
    consentTo(type) {
        const prefs = this.getCookiePreferences();
        return prefs && prefs[type] === true;
    },
    
    loadConsentedScripts(preferences) {
        if (!preferences) {
            preferences = this.getCookiePreferences();
        }
        
        if (!preferences) return;
        
        if (preferences.analytics) {
            this.loadGoogleAnalytics();
        }
        
        if (preferences.marketing) {
            this.loadGoogleTagManager();
        }
    },
    
    loadGoogleAnalytics() {
        // Load Google Analytics dynamically
        const gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-SHNNW99DZ4';
        document.head.appendChild(gaScript);
        
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-SHNNW99DZ4');
        
        // Execute the gtag function if it's not already defined
        if (typeof window.gtag !== 'function') {
            window.gtag = gtag;
        }
    },
    
    loadGoogleTagManager() {
        // Load Google Tag Manager
        (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PRCPPDMM');
        
        // Add noscript iframe if it doesn't exist
        if (!document.querySelector('noscript iframe[src*="GTM-PRCPPDMM"]')) {
            const noscript = document.createElement('noscript');
            const iframe = document.createElement('iframe');
            iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-PRCPPDMM";
            iframe.height = "0";
            iframe.width = "0";
            iframe.style.display = "none";
            iframe.style.visibility = "hidden";
            noscript.appendChild(iframe);
            document.body.insertBefore(noscript, document.body.firstChild);
        }
    }
}
